// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__321gk","requiredAsterisk":"Info_requiredAsterisk__3wRV6"};